




















import { Component, Vue } from 'vue-property-decorator';
import { ColorUpdater } from "bulma-css-vars";
import { bulmaCssVariablesDefs } from "@/assets/bulma-generated/bulma-colors";

const updater = new ColorUpdater(bulmaCssVariablesDefs as any)

@Component({})
export default class App extends Vue {
  ordine: string = process.env.VUE_APP_ORDINE;
  ordineid: string = process.env.VUE_APP_ORDINE_ID;
  primaryColor: string = process.env.VUE_APP_PRIMARY_COLOR;

  get logo(): string {
    return require(`@/assets/images/logo_${this.ordineid}.png`);
  }

  mounted() {
    const container = this.$refs.bcvContainer as any;
    let updatedVars = updater.getUpdatedVars("primary", this.primaryColor);
    updatedVars.forEach(({ name, value }) => {
        container.style.setProperty(name, value);
    });
    updatedVars = updater.getUpdatedVars("link", this.primaryColor);
    updatedVars.forEach(({ name, value }) => {
        container.style.setProperty(name, value);
    });
  }
}
